import { RSAA } from 'redux-api-middleware';
import { createRsaaTypes, createHeaders } from './actionHelpers';

export const FAQS_LIST = 'FAQS_LIST';

export const fetchFaqs = () => ({
    [RSAA]: {
        types: createRsaaTypes(FAQS_LIST),
        endpoint: '/api/faqs',
        headers: createHeaders(false),
        method: 'GET'
    }
});
